/**
 * Push-Registrierung für die Dartmin-App (Capacitor).
 *
 * Läuft nur innerhalb der nativen App (window.Capacitor.isNativePlatform()).
 * Im normalen Browser passiert nichts.
 *
 * Anders als eine cookie-basierte Session nutzt dieses Backend ausschließlich
 * Bearer-Token-Auth (Authorization: Bearer <keycloak.token>, siehe httpClient.ts).
 * Der Token wird daher explizit übergeben statt auf credentials:'include' zu setzen.
 */

import { navigateFromPush } from "./navigation";

const REGISTER_ENDPOINT = "/api/push/register";

let started = false;

export function registerPushNotifications(getToken: () => string | undefined) {
  if (started) return;
  started = true;

  const cap = (window as any).Capacitor;
  if (!cap || !cap.isNativePlatform || !cap.isNativePlatform()) {
    return; // Normaler Browser: nichts zu tun.
  }

  const push = cap.Plugins && cap.Plugins.PushNotifications;
  if (!push) {
    console.warn("[dartmin-push] PushNotifications-Plugin nicht verfügbar");
    return;
  }

  async function sendeTokenAnBackend(token: string) {
    const accessToken = getToken();
    if (!accessToken) {
      console.warn("[dartmin-push] Kein Access-Token vorhanden, Registrierung übersprungen");
      return;
    }

    try {
      const res = await fetch(REGISTER_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          token,
          platform: cap.getPlatform(), // 'ios' oder 'android'
        }),
      });
      if (!res.ok) {
        console.warn("[dartmin-push] Registrierung fehlgeschlagen:", res.status);
      }
    } catch (err) {
      console.warn("[dartmin-push] Token konnte nicht gespeichert werden:", err);
    }
  }

  push.addListener("registration", (result: { value: string }) => {
    sendeTokenAnBackend(result.value);
  });

  push.addListener("registrationError", (err: any) => {
    console.warn("[dartmin-push] Registrierung fehlgeschlagen:", JSON.stringify(err));
  });

  // Benutzer tippt auf eine Benachrichtigung: optional zu einer URL aus den
  // Zusatzdaten der Nachricht springen (Feld "url" im data-Teil der Nachricht).
  push.addListener("pushNotificationActionPerformed", (action: any) => {
    const data = action?.notification?.data;
    if (data?.url && typeof data.url === "string" && data.url.indexOf("/") === 0) {
      navigateFromPush(data.url);
    }
  });

  push
    .checkPermissions()
    .then((status: any) => {
      if (status.receive === "prompt") {
        return push.requestPermissions();
      }
      return status;
    })
    .then((status: any) => {
      if (status.receive === "granted") {
        return push.register();
      }
      console.warn("[dartmin-push] Push-Erlaubnis nicht erteilt");
    })
    .catch((err: any) => {
      console.warn("[dartmin-push] Fehler bei der Push-Einrichtung:", err);
    });
}
